import { render } from "./Audio.vue?vue&type=template&id=4d274410&scoped=true"
import script from "./Audio.vue?vue&type=script&lang=js"
export * from "./Audio.vue?vue&type=script&lang=js"

import "./Audio.vue?vue&type=style&index=0&id=4d274410&lang=css"
import "./Audio.vue?vue&type=style&index=1&id=4d274410&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d274410"]])

export default __exports__